import { init } from 'trackux'

import { trackPageView } from './src/lib/analytics/ga'

let hasTrackedInitialMetaPageView = false

function isLocalMetaPixelBlocked() {
  if (typeof window === 'undefined') return true

  const hostname = window.location.hostname.toLowerCase()

  return (
    hostname === 'localhost' ||
    /^127(?:\.\d{1,3}){3}$/.test(hostname) ||
    hostname === '0.0.0.0' ||
    hostname === '::1' ||
    hostname === '[::1]' ||
    hostname.endsWith('.localhost')
  )
}

function trackMetaPageView() {
  if (typeof window === 'undefined') return
  if (isLocalMetaPixelBlocked()) return

  if (!hasTrackedInitialMetaPageView) {
    hasTrackedInitialMetaPageView = true
    return
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }
}

export const onRouteUpdate = ({ location }) => {
  trackPageView(location)
  trackMetaPageView()
}

// TrackUX init (managed by `npx trackux`)
init({
  projectId: 'proj_6e3a8ad22b8f4008b8d086b1fc0c47b2',
  publicKey: 'pub_a771e8a2116344a79a82e9b6061bac74',
  endpoint: 'https://trackux-ingestion.frank-bonnet.workers.dev',
  environment: 'production',
  autoCapture: {
    pageViews: true,
    clicks: true,
    behavior: true,
    forms: true,
    scrollDepth: false,
  },
})
